import Player from 'video.js/dist/types/player';

export const updateTimeAndDuration = (
    players: Player[],
    setCurrentTime: (time: number) => void,
    setMaxDuration: (duration: number) => void
) => {
    const { totalTime, count, longest } = players.reduce(
        (acc, player) => {
            if (!player || player.isDisposed()) return acc;

            const time = player.currentTime();
            const duration = player.duration();

            if (time && !isNaN(time)) {
                acc.totalTime += time;
                acc.count++;
            }

            if (duration && !isNaN(duration) && duration !== Infinity) {
                acc.longest = Math.max(acc.longest, duration);
            }

            return acc;
        },
        { totalTime: 0, count: 0, longest: 0 }
    );

    if (count > 0) {
        setCurrentTime(totalTime / count);
        setMaxDuration(longest);
    }
};

export const syncPlayStateFromAnyPlayer = (
    players: Player[],
    setIsPlaying: (v: boolean) => void
) => {
    if (players.length === 0) return;

    const anyPlaying = players.some((p) => p && !p.isDisposed() && !p.paused());

    if (anyPlaying) {
        setIsPlaying(true);

        players.forEach((p) => {
            if (p && !p.isDisposed() && p.paused()) {
                p.play();
            }
        });
    } else {
        setIsPlaying(false);
    }
};
